function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBtnGraphicSmall({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    id: "prefix__btn-graphic_small",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("rect", {
    id: "prefix__btn-graphic_small_surface",
    width: 24,
    height: 24,
    rx: 5,
    style: {
      fill: "#efebf6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "prefix__ic_edit_24px",
    d: "M3 11.084v2.128h2.128L11.4 6.937 9.275 4.809zm10.049-5.793a.565.565 0 0 0 0-.8l-1.328-1.328a.565.565 0 0 0-.8 0L9.883 4.2l2.127 2.13 1.038-1.038z",
    transform: "translate(4.026 4.029)",
    style: {
      fill: "#7644c9"
    }
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBtnGraphicSmall);
export default __webpack_public_path__ + "static/media/btn-graphic_small.9ac039d32c06f5afad7a4c163d47e983.svg";
export { ForwardRef as ReactComponent };